export function KeyboardEnterIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 5H18C19.6569 5 21 6.34315 21 8V13C21 14.6569 19.6569 16 18 16H8"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path d="M2 16L8 12L8 20L2 16Z" fill="currentColor" />
    </svg>
  );
}
